<template>
  <v-container fluid>
    <v-row v-for="(item, index) in items" :key="index">
      <v-col cols="12" xs="12" sm="12" md="6">
        <note-item
          :note="item"
          :claimLines="claimLines"
          :claimSubmission="claimSubmission"
          @save="save($event, index)"
          @delete="deleteNote(index)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NoteItem from "./NoteItem.vue";
export default {
  components: {
    NoteItem,
  },
  props: ["claimSubmission", "planNumber", "planName"],
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    claimLines() {
      const lines = [];
      for (let i = 0; i < this.claimSubmission.Claims.length; i++) {
        lines.push(i + 1);
      }
      return lines;
    },
  },
  mounted() {
    if (this.claimSubmission.Notes) {
      this.items = JSON.parse(JSON.stringify(this.claimSubmission.Notes));
    } else {
      this.items = [
        {
          Identifier: Math.random().toString(),
          Writer: this.user,
        },
      ];
    }
    console.log(this.items);
    this.$forceUpdate();
  },
  methods: {
    save(note, index) {
      // console.log(this.items, this.items[0].Timestamp);
      this.items[index] = note;
      if (this.items[0].Timestamp !== undefined && this.items[0].Timestamp !== null) {
        this.items.unshift({
          Identifier: Math.random().toString(),
          Writer: this.user,
        });
      }
      // this.$emit("notes",this.items);
      this.claimSubmission.Notes = this.items.filter(
        (o) => o.Timestamp !== undefined
      );
      this.$emit("valid");
    },
    deleteNote(index) {
      this.items.splice(index, 1);
      // this.$emit("notes",this.items);
      this.claimSubmission.Notes = this.items.filter(
        (o) => o.Timestamp !== undefined
      );
      this.$emit("valid");
    },
  },
};
</script>
<style scoped></style>
